module.exports = __webpack_public_path__ + "static/media/cutsglare_japanese_00227.89558915.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/jp/cutsglare_japanese_00227.png
// module id = 2452
// module chunks = 0